module.exports = __webpack_public_path__ + "img/moses.c402ca10.webp";